// generated by the plop


import { PaginatorModel, PROGRESS_STATUSES } from 'symbols';
import {
  CategoryOfTransactionModel,
  CategoryStatisticsModel,
  CurrencyPriceModel,
  FinanceScoreModel,
  TransactionModel
} from '../../symbols';

export interface FinanceRegisterStateModel {
  currencies: CurrencyPriceModel[];
  scopes: FinanceScoreModel[];
  loadScopesStatuses: PROGRESS_STATUSES;
  categories: CategoryOfTransactionModel[];
  loadCategoriesStatuses: PROGRESS_STATUSES;
  transactionList: PaginatorModel<TransactionModel>;
  loadTransactionListStatus: PROGRESS_STATUSES;
  createTransactionStatus: PROGRESS_STATUSES;
  categoryStatisticsStatus: PROGRESS_STATUSES;
  categoryStatistics: CategoryStatisticsModel;
}

export const FINANCE_REGISTER_STATE_DEFAULT: FinanceRegisterStateModel = {
  currencies: [],
  scopes: [],
  loadScopesStatuses: PROGRESS_STATUSES.NOT_INITIALIZED,
  categories: [],
  loadCategoriesStatuses: PROGRESS_STATUSES.NOT_INITIALIZED,
  transactionList: {
    data: [],
    links: null,
    meta: null
  },
  loadTransactionListStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  createTransactionStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  categoryStatisticsStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  categoryStatistics: null
};
